import { render } from "./KSCreateGroup.vue?vue&type=template&id=3e0965e0&scoped=true"
import script from "./KSCreateGroup.vue?vue&type=script&lang=js"
export * from "./KSCreateGroup.vue?vue&type=script&lang=js"

import "./KSCreateGroup.vue?vue&type=style&index=0&id=3e0965e0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e0965e0"]])

export default __exports__